import { mount } from "svelte";
import "./app.css";
import App from "./App.svelte";
import SpotPreview from "$lib/spot/SpotPreview.svelte";
import { isPreviewRoute } from "$lib/utils/previewMode";

// NOTE: preloadError is failure to load dynamic imports https://vite.dev/guide/build#load-error-handling
// related to new deployments, depends on the host.
window.addEventListener("vite:preloadError", (event) => {
  // event.preventDefault(); // prevent the error from being thrown
  window.location.reload();
});

const Root = isPreviewRoute() ? SpotPreview : App;
const app = mount(Root, { target: document.getElementById("app")! });

export default app;
